module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kaffeehaus"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.headline)
    }
  }), _c('seperator'), _c('div', {
    staticClass: "body"
  }, [_vm._l((_vm.body), function(paragraph) {
    return _c('p', {
      domProps: {
        "innerHTML": _vm._s(paragraph)
      }
    })
  }), _c('form', {
    attrs: {
      "action": "http://donauhofwien.at/mailchimp.php",
      "method": "put"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitForm($event)
      }
    }
  }, [_c('label', {
    staticClass: "name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Name",
      "value": "",
      "name": "NAME",
      "required": "required",
      "disabled": _vm.form.response
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value)
      }
    }
  })]), _c('label', {
    staticClass: "email"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.email),
      expression: "form.email"
    }],
    attrs: {
      "type": "email",
      "placeholder": "Email Adresse",
      "value": "",
      "name": "EMAIL",
      "disabled": _vm.form.response
    },
    domProps: {
      "value": (_vm.form.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "email", $event.target.value)
      }
    }
  })]), _c('button', {
    staticClass: "cta",
    attrs: {
      "type": "submit",
      "disabled": _vm.form.response
    }
  }, [_vm._v("Anmelden")])]), (_vm.form.response) ? _c('transition', {
    attrs: {
      "name": "response",
      "mode": "out-in",
      "appear": "appear"
    }
  }, [_c('p', {
    key: _vm.form.response,
    staticClass: "response",
    domProps: {
      "innerHTML": _vm._s(_vm.form.response)
    }
  })]) : _vm._e()], 2), _c('div', {
    staticClass: "clear"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-143a126b"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Kaffeehaus.vue
// module id = 420
// module chunks = 1